import instance from '../../../api/axios'
import { FolderItem } from '../types/files'

export interface CreateFolderPayload {
  name: string
  parentId?: string
}

export const createFolder = async (
  payload: CreateFolderPayload,
): Promise<FolderItem> => {
  const response = await instance.post('/files/folders', payload)
  return response.data
}

export default createFolder
